<template>
  <v-container>
    <v-card class="mx-auto rounded-lg mt-5" elevation="0" outlined>
      <v-card-text class="secondary-font pa-3">
        <v-container class="mt-3">
          <v-row>
            <v-col cols="12" class="my-0 py-0">
              <span class="mb-0 mr-1 primary--text font-weight-medium">
                Student Name:
              </span>
              <span class="mb-0 black--text">
                {{ user && user.name }}
              </span>
            </v-col>
            <v-col cols="12" class="my-0 py-0">
              <span class="mb-0 mr-1 primary--text font-weight-medium">
                Student Mail:
              </span>
              <span class="mb-0 black--text">
                {{ user && user.email }}
              </span>
            </v-col>
            <v-col cols="12" class="mb-0 pb-0">
              <v-select
                :items="enrollmentYears"
                :item-text="
                  (item) =>
                    `${item.academic_year.academic_year} ${item.program_detail.program.program_desc}`
                "
                item-value="uuid"
                v-model="enrollmentYearUuid"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              class="my-0 py-0"
              v-if="enrollmentYears.length > 0"
            >
              <v-tabs v-model="tab">
                <v-tab> Enrollment </v-tab>
                <v-tab> Grade </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <EnrollmentsTab
                    :enrollmentTerms="enrollmentYear.enrollment_terms"
                    :enrollmentYear="enrollmentYear"
                  />
                </v-tab-item>
                <v-tab-item>
                  <GradesTab
                    :enrollmentTerms="enrollmentYear.enrollment_terms"
                    :handlePrintTranscript="handlePrintTranscript"
                  />
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import enrollmentService from "@/services/enrollment-service";
import EnrollmentsTab from "@/components/general/EnrollmentsTab.component.vue";
import GradesTab from "@/components/general/GradesTab.component.vue";
import studentsService from "@/services/students-service";
export default {
  components: { EnrollmentsTab, GradesTab },
  data() {
    return {
      enrollmentYears: [],
      enrollmentYearUuid: {},
      enrollmentYear: {},
      tab: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
  watch: {
    enrollmentYearUuid() {
      this.enrollmentYear = this.enrollmentYears.find(
        (enrollmentYear) => enrollmentYear.uuid == this.enrollmentYearUuid
      );
    },
  },
  mounted() {
    this.getEnrollmentDetails();
  },
  methods: {
    getEnrollmentDetails() {
      enrollmentService.getEnrollmentDetails().then((response) => {
        this.enrollmentYears = response.data;
        this.enrollmentYear = response.data ? response.data[0] : null;
        this.enrollmentYearUuid = response.data ? response.data[0].uuid : null;
      });
    },
    handlePrintTranscript() {
      studentsService
        .getTranscript(this.enrollmentYear.uuid)
        .then((response) => {
          var file = new Blob([response], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        });
    },
  },
};
</script>
